import React from 'react';
import {
	Grid,
	TextField,
	Box,
	Typography,
	InputAdornment,
} from '@mui/material';
import { Expense } from '../../gql/graphql';
import { useShopDetails } from '../../hooks/use-shop';

interface BasicInfoTabProps {
	expenseData: Partial<Expense>;
	updateExpenseData: (updates: Partial<Expense>) => void;
}

function BasicInfoTab({ expenseData, updateExpenseData }: BasicInfoTabProps) {
	const { shopId, locationId } = useShopDetails();

	// Initialize shopId and locationId if not set
	React.useEffect(() => {
		if (!expenseData.shopId) {
			updateExpenseData({ shopId, locationId });
		}
	}, []);

	const handleChange = (field: keyof Expense) => (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		const value = event.target.type === 'number' ? parseFloat(event.target.value) : event.target.value;
		updateExpenseData({ [field]: value });
	};

	return (
		<Box>
			<Typography variant="h6" gutterBottom>
				Basic Expense Information
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
				Enter the expense details
			</Typography>

			<Grid container spacing={3}>
				{/* Expense Name */}
				<Grid item xs={12}>
					<TextField
						fullWidth
						required
						label="Expense Name"
						name="name"
						value={expenseData.name || ''}
						onChange={handleChange('name')}
						helperText="Enter a descriptive expense name"
					/>
				</Grid>

				{/* Price */}
				<Grid item xs={12} md={6}>
					<TextField
						fullWidth
						required
						label="Amount"
						name="price"
						type="number"
						value={expenseData.price || ''}
						onChange={handleChange('price')}
						InputProps={{
							startAdornment: <InputAdornment position="start">₹</InputAdornment>,
						}}
						helperText="Expense amount"
					/>
				</Grid>

				{/* Description */}
				<Grid item xs={12}>
					<TextField
						fullWidth
						multiline
						rows={6}
						label="Description"
						name="description"
						value={expenseData.description || ''}
						onChange={handleChange('description')}
						helperText="Detailed expense description"
					/>
				</Grid>
			</Grid>
		</Box>
	);
}

export default BasicInfoTab;
